export function resetObjectProperties(obj, ignoreKeys = []) {
  const keys = Object.keys(obj);
  keys
    .filter((key) => !ignoreKeys.includes(key))
    .forEach((i) => (obj[i] = null));
}
